/**
 * Per-machine QZ Tray printer assignment (AROS-1996).
 *
 * Which physical printer is the "receipt" printer and which is the "label"
 * printer is a property of the machine the browser runs on, not of the
 * logged-in user's account — so it's kept in localStorage rather than sent
 * to the backend.
 */

const STORAGE_KEY = 'qz-printer-settings'

export interface QzPrinterSettings {
  receiptPrinter: string | null
  labelPrinter: string | null
}

const DEFAULT_SETTINGS: QzPrinterSettings = {
  receiptPrinter: null,
  labelPrinter: null,
}

export const getQzPrinterSettings = (): QzPrinterSettings => {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) return { ...DEFAULT_SETTINGS }

  try {
    const parsed = JSON.parse(raw) as Partial<QzPrinterSettings>
    return {
      receiptPrinter: parsed.receiptPrinter ?? null,
      labelPrinter: parsed.labelPrinter ?? null,
    }
  } catch {
    return { ...DEFAULT_SETTINGS }
  }
}

export const setQzPrinterSetting = (
  kind: keyof QzPrinterSettings,
  value: string | null
): QzPrinterSettings => {
  const next = { ...getQzPrinterSettings(), [kind]: value }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  return next
}
